import React from 'react';
import { motion } from 'framer-motion';
interface PageBannerProps {
  title: string;
  subtitle?: string;
  backgroundImage?: string;
}
export function PageBanner({
  title,
  subtitle,
  backgroundImage
}: PageBannerProps) {
  return <section className="relative pt-44 pb-32 md:pt-52 md:pb-40 flex items-center justify-center overflow-hidden" data-id="element-365">
      {/* Background Image */}
      {backgroundImage && <div className="absolute inset-0" data-id="element-366">
          <img src={backgroundImage} alt="" className="w-full h-full object-cover" data-id="element-367" />
          <div className="absolute inset-0 bg-gradient-to-t from-jet/85 via-jet/55 to-jet/30" data-id="element-368"></div>
          <div className="absolute inset-0 bg-burgundy/15 mix-blend-multiply" data-id="element-369"></div>
          <div className="absolute inset-0 backdrop-blur-[2px]" data-id="element-370"></div>
        </div>}

      <div className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-371">
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-4xl md:text-6xl font-heading font-bold text-white mb-4" data-id="element-372">
          {title}
        </motion.h1>
        {subtitle && <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-lg md:text-xl text-white/90 font-body mb-8" data-id="element-373">
            {subtitle}
          </motion.p>}

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-374">
          <a href="tel:2409217857" className="inline-block px-8 py-4 bg-brand-gold text-cream font-bold uppercase tracking-widest text-sm rounded-full hover:bg-near-black transition-colors shadow-lg hover:shadow-xl" data-id="element-375">
            Call to Book
          </a>
        </motion.div>
      </div>
    </section>;
}